import { Controller } from "@hotwired/stimulus"
import debounce from "lodash/debounce"
import type { TurboSubmitStartEvent } from "@hotwired/turbo"

export default class SearchFormController extends Controller {
  static targets = ["form"]

  declare formTarget: HTMLFormElement
  declare debouncedSubmit: () => void
  declare boundInjectUrlParams: (event: TurboSubmitStartEvent) => void

  connect() {
    this.debouncedSubmit = debounce(this.submit.bind(this), 300)
    this.boundInjectUrlParams = this.injectUrlParams.bind(this)
    this.formTarget.addEventListener(
      "turbo:submit-start",
      this.boundInjectUrlParams as EventListener
    )
  }

  disconnect() {
    this.formTarget.removeEventListener(
      "turbo:submit-start",
      this.boundInjectUrlParams as EventListener
    )
  }

  search() {
    this.debouncedSubmit()
  }

  submit() {
    this.formTarget.requestSubmit()
  }

  injectUrlParams(event: TurboSubmitStartEvent) {
    const body = event.detail.formSubmission.fetchRequest.body

    const sort = this.urlSort()
    if (sort && !body.has("q[s]")) {
      body.append("q[s]", sort)
    }
  }

  searchParams(): FormData {
    const params = new FormData(this.formTarget)

    const sort = this.urlSort()
    if (sort && !params.has("q[s]")) {
      params.append("q[s]", sort)
    }
    return params
  }

  private urlSort(): string | null {
    return new URL(window.location.href).searchParams.get("q[s]")
  }
}
